import React from 'react';

const NotFound = () => {
    return (
        <div className='d-flex mt-5 flex-column align-items-center justify-content-center text-danger'>
            <h1 className='mt-5'>404</h1>
            <h1 className='mb-5'>Page Not Found</h1>
        </div>
    );
};

export default NotFound;